import "./style.css";

const WeeklySchedule = () => {
  return (
    <div className="cart-page weekly-schedule bg-custom">
      <div className="cart-table">
        <table className="font-antonio">
          <thead>
            <tr>
              <th className="text-clip">Date</th>
              <th className="text-clip">Location</th>
              <th className="text-clip">Time</th>
            </tr>
          </thead>
          <tbody>
            <tr className="border-1">
              <td className="pdt-name-first text-clip">
                Monday, September 22 2025
              </td>
              <td>
                <div className="location-desc-col">
                  <p className="text-clip">Holy Family (366 Watchogue Road)</p>
                </div>
              </td>
              <td className="text-clip">4:00 PM to 6:00 PM</td>
            </tr>
            <tr className="border-1">
              <td className="pdt-name-first text-clip">
                Tuesday, September 23 2025
              </td>
              <td>
                <div className="location-desc-col">
                  <p className="text-clip">
                    Jump Shotz (120 Androvette Street)
                  </p>
                  <p className="text-clip">Holy Family (366 Watchogue Road)</p>
                </div>
              </td>
              <td>
                <div className="location-desc-col">
                  <p className="text-clip">4:00 PM to 6:00 PM</p>
                  <p className="text-clip">6:30 PM to 8:30 PM</p>
                </div>
              </td>
            </tr>
            <tr className="border-1">
              <td className="pdt-name-first text-clip">
                Tuesday, September 23 2025
              </td>
              <td>
                <div className="location-desc-col">
                  <p className="text-clip">
                    Jump Shotz (120 Androvette Street)
                  </p>
                  <p className="text-clip">Holy Family (366 Watchogue Road)</p>
                </div>
              </td>
              <td>
                <div className="location-desc-col">
                  <p className="text-clip">4:00 PM to 6:00 PM</p>
                  <p className="text-clip">6:30 PM to 8:30 PM</p>
                </div>
              </td>
            </tr>
          </tbody>
        </table>
      </div>
    </div>
  );
};
export default WeeklySchedule;
